export const roleIdSix = 6; // for 2 IOT login login